<p-dataView 
  #dv 
  [value]="cursos" 
  *ngIf="!loading" 
  layout="grid" 
  filterBy="nombre" 
  [sortField]="sortField" 
  [paginator]="pagination" 
  [rows]="itemsPerPage"
  [sortOrder]="sortOrder">

  <ng-template pTemplate="header">
    <input type="text" pInputText class="p-mr-2" placeholder="Buscar curso" (input)="dv.filter($event.target.value, 'contains')">
  
    <p-dropdown class="p-mr-2" [options]="sortOptions" [(ngModel)]="sortKey" placeholder="Ordenar por" (onChange)="onSortChange($event)" [style]="{'min-width':'15em'}"></p-dropdown>

  </ng-template>

  <ng-template let-curso pTemplate="gridItem">

    <div class="p-col-6 p-sm-10 p-md-6 p-lg-3 p-xl-3" style="padding: 5px;">
      <p-card (click)="goFormulario(curso.id, curso.version)">
      <ng-template pTemplate="header">
        <div class="img" [style]="{backgroundImage: 'url(' + curso.imagen_base64 + ')', backgroundSize: 'cover'}">
          <div style="min-height: 220px;"></div>
        </div>
      </ng-template>
      <div class="p-d-flex p-p-1 p-flex-nowrap p-jc-between">
        <small class="p-text-left" style="max-width: 120px; font-size: .8rem;">{{ curso.categoria }}</small>
        <small class="curso-duracion p-as-center" style="font-size: .7rem; color: #000;">{{ curso.duracion}} Horas</small>
      </div>
      <div class="p-text-left p-p-1">
        <h3 class="p-mb-0 p-mt-0 p-text-nowrap p-text-truncate" style="font-size: .93rem; max-width: 200px;">{{ curso.nombre }}</h3>
        <div class="p-mt-1 p-mb-2">
          <small class="p-py-0 p-my-0" style="font-size: .7rem">{{curso.tipoCurso}}</small><br>
          <p class="p-py-0 p-my-0" *ngIf="curso.tipoCurso !== 'GRATUITO' && curso.tipoCurso !== 'PRIVADO'" style="font-size: .7rem">Valor: $ {{curso.valorArancel + curso.valorMatricula}}</p>
        </div>
        <div>
          <small *ngIf="curso.estado == 'INACTIVO'" class="p-text-uppercase p-card-nodisponible" style="font-size: .7rem"><i class="pi pi-times-circle p-mr-1" style="top: 2px; position:relative;"></i> No disponible</small>
          <small *ngIf="curso.estado !== 'INACTIVO'" class="p-text-uppercase p-card-disponible" style="font-size: .7rem"><i class="pi pi-info-circle p-mr-1" style="top: 2px; position:relative;"></i> Más info </small>
        </div>
        <div *ngIf="curso.requiereCodigo" class="p-mt-2">
          <small [ngClass]="curso.estado !== 'INACTIVO' ? 'p-text-uppercase p-card-exclusivo' : 'p-text-uppercase p-card-text-disabled p-card-nodisponible'" style="font-size: .7rem"><i class="pi pi-key p-mr-1" style="top: 2px; position:relative;"></i> Requiere código</small>
        </div>
      </div>
    </p-card>  
    </div>


  </ng-template>

  <ng-template pTemplate="empty">
    <div class="p-col-12 p-text-center">
      <p>No se han encontrado cursos.</p>
    </div>
  </ng-template>

</p-dataView>

<div *ngIf="loading"  class="p-grid p-m-0 p-jc-start">
  <div *ngFor="let curso of [1,2,3]" style="max-width: 300px;" class="p-col-6 p-sm-6 p-md-4 p-lg-3 p-xl-3 p-py-1 p-py-sm-1 p-py-md-2 p-py-lg-2 p-py-xl-3 p-px-2 p-px-sm-2 p-px-md-2 p-px-lg-1 p-px-xl-2">
    <div class="p-card-enabled" style="height: 100%;">
      <p-card>
        <ng-template pTemplate="header">
          <div style="width: 100%;">
            <p-skeleton width="100%" height="220px"></p-skeleton>
          </div>
        </ng-template>
        <div class="p-mt-2 p-d-flex p-flex-nowrap p-jc-between" style="opacity: .5;">
          <small class="p-text-left" style="max-width: 120px; font-size: .8rem;"> Cargando las categorías... </small>
          <small class="curso-duracion p-as-center" style="font-size: .7rem">N° Horas</small>
        </div>
        <div class="p-text-left" style="opacity: .5; margin-top: 5px;">
          <h3 class="p-mb-0 p-mt-0" style="font-size: .93rem">Cargando... </h3>
          <div class="p-mt-1 p-mb-2">
            <!-- Muestra el tipo de curso -->
            <div style="width: 90px; height: 10px;">
            </div>
          </div>
          <div>
            <small class="p-text-uppercase p-card-disponible" style="font-size: .7rem"><i class="pi pi-info-circle p-mr-1" style="top: 2px; position:relative;"></i> Más info </small>
          </div>
 
        </div>
      </p-card>
    </div>

  </div>
</div>
